var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview-table"},[_c('base-list-management',{ref:"baseListRef",attrs:{"configData":_setup.configData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }